import { render } from "./HouseBreakdown.vue?vue&type=template&id=04335709&scoped=true"
import script from "./HouseBreakdown.vue?vue&type=script&lang=js"
export * from "./HouseBreakdown.vue?vue&type=script&lang=js"

import "./HouseBreakdown.vue?vue&type=style&index=0&id=04335709&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04335709"]])

export default __exports__